module.exports = __webpack_public_path__ + "3aa223c8cc48eba75fbb57fcc20ce7cc.svg";